import { getAllNodes, LmNode, LmPath, selectMany } from "../omnia"
import { findMultiplePaths } from "./explorer"

export type ExpandCollapseState = "expand" | "collapse" | "expand-layers"

export function getNextExpandedState(rootNodes: LmNode[]): { state: ExpandCollapseState, action: () => void } {

    if (!rootNodes) return { state: "collapse", action: () => { } }

    const level1 = rootNodes.some(n => n.expanded)

    if (!level1) {
        return {
            state: "expand",
            action: toggle(rootNodes)
        }
    }

    const visible = getPathsToVisibleLayers(rootNodes)

    if (visible.some(hasCollapsedNodes)) {

        return {
            state: "expand-layers",
            action: toggle(selectMany(visible))
        }

    }

    return {
        state: "collapse",
        action: toggle([])
    }

    ///

    function toggle(nodes: LmNode[]) {
        return () => {
            const all = getAllNodes(rootNodes)
            all.forEach(n => n.expanded = false)
            nodes.forEach(n => n.expanded = true)
        }
    }

}

function hasCollapsedNodes(path: LmPath) {
    return path.some(n => !n.expanded)
}

function getPathsToVisibleLayers(rootNodes: LmNode[]) {


    const paths = findMultiplePaths(
        rootNodes,
        hasVisibleLayers,
        n => n.getChildren(true)
    )

    return paths

    function hasVisibleLayers(n: LmNode) {
        const children = n.getChildren(true)
        return children && children.some(c => c.layer && c.layer.visible)
    }

}

export function getNextExpandedStateCss(rootNodes: LmNode[]) {

    switch (getNextExpandedState(rootNodes).state) {

        case "collapse":
            return "fas fa-angle-up"

        case "expand":
            return "fas fa-angle-down"

        case "expand-layers":
            return "fas fa-angle-double-down"

    }

}
